export enum CommissionsCategory {
  PRIMARY = "PRIMARY",
  PRIMARY_TIPPER = "PRIMARY_TIPPER",
  PRIMARY_BROKER = "PRIMARY_BROKER",
  SECONDARY = "SECONDARY",
}

export enum CommissionShortcut {
  Z = "Z",
  U = "U",
  N = "N",
  B = "B",
  MP = "MP",
}
